import * as React from 'react';
import classNames from 'classnames';

import { MainSettings } from './MainSettings';

/**
 * Renders the main style editor (styling of the surrounding widget element).
 */
export class Main extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { value, name: key, onChange, defaults, active, isInPlainCell } = this.props;

        return (
            <div className={classNames('widget-style-main', active && 'widget-style-main--is-active')}>
                <div className="widget-style-main__settings">
                    {active && (
                        <MainSettings
                            value={value}
                            name={key}
                            onChange={onChange}
                            defaults={defaults}
                            isInPlainCell={isInPlainCell}
                        />
                    )}
                </div>
            </div>
        );
    }
}
